import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import Marvin from '@Containers/StructureEditor/Marvin';


export default function ViewIn3D (props) {
  const { structure } = props;
  const editorRef = useRef(null);

  useEffect(() => {

    editorRef
      .current
      .instance
      .importStructure(structure);
  }, [structure]);

  return (
    <Marvin
      ref={editorRef}
      editMode={false}
      tabIndex="-1"
    />
  );
}

ViewIn3D.propTypes = {
  structure: PropTypes.string.isRequired,
};
